const constants = {
  pageReady: false,
  is: 'desktop',
  windW: 0,
  windH: 0,
  windOldW: 0,
  windOldH: 0,

  captchaIsEnterprise: window.ent,
  captchaKey: window.sk,
  captchaAction: window.act,

  wresizetimer: 100,
  resizetimeout: 0,
  timerout: 0,

  zoomLevel: 100,

  scr: {
    phone: 0,
    tablet: 768,
    desktop: 1280,
  },
  slick: {
    edgeFriction: 0,
    speed: 300,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
  },
  fileTypes: {
    jpeg: 'image/jpeg',
    pdf: 'application/pdf',
  },
  lang: {
    el: 'el',
    en: 'en',
  },
  locale: {
    el: 'el-GR',
    en: 'en-GB',
  },
  gridGutterWidth: 24,
  gridGutterWidthMob: 26,
  youtube: false,

  scrollToAlertOffset: -25,

  prepaidVoucherType: 'prepaid',
  discountVoucherType: 'promocode',
  noVoucherType: 'none',

  buttonPaymentSubmitId: 'buttonPaymentSubmit',

  regex: {
    greekLatin:
      /^[A-Za-zΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωςάέήύόίώϊϋΆΈΉΊΌΎΏΆΈΉΊΌΎΏΪΫϋΰΐ]+$/u,
    greekLatinSpace:
      /^[A-Za-zΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωςάέήύόίώϊϋΆΈΉΊΌΎΏΆΈΉΊΌΎΏΪΫϋΰΐ\s]+$/u,
    telephone: /^(\+\d{1,3})?(?:\d+-?){10,}$/,
    greekMobilePhone: /^69\d{8}$/,
    // eslint-disable-next-line no-useless-escape
    password: /(?=.*[A-Z])(?=.*\d)(?=.*[#$@!\^%&*?])[A-Za-z0-9\^#$@!%&*?]{8,}$/,
    otp: /\d{6}/,
  },

  noImg: '/assets/imgs/helpers/No-Image.jpg',
  filters: {
    cinemas: 'cinemas',
    roomTypes: 'roomTypes',
    screenTypes: 'screenTypes',
  },

  vouchers: {
    prepaid: {
      length: 17,
    },
    discount: {
      length: 20,
    },
  },
  timezone: 'Europe/Athens',
  calendar: {
    defaultDays: 15,
  },
  socialLogin: {
    status: {
      loggedIn: 'loggedin',
      pendingRegistration: 'pendingregistration',
    },
  },
  deviceType: {
    website: 'website',
    application: 'application',
  },
}

export default constants
